/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { SlSdata } from "../../models/sl-sdata";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetSubscriptionSls$Params {
  subscription_id: string;
  year: number;
  month: number;
}

export function getSubscriptionSls(
  http: HttpClient,
  rootUrl: string,
  params: GetSubscriptionSls$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SlSdata>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionSls.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
    rb.path("year", params.year, {});
    rb.path("month", params.month, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SlSdata>;
    }),
  );
}

getSubscriptionSls.PATH = "/dashboard/stats/sls/{subscription_id}/{year}/{month}";
